module.exports = __webpack_public_path__ + "images/feature/20161107_01-a00d9a7f022a1aa3a6cff8c6b5022760.jpg";